import KullaniciPrinterDTO from "src/models/Printer/KullaniciPrinterDTO";
import PrinterRequest from "src/models/Printer/Request/PrinterRequest";
import { ApiService } from "../core";

class KullaniciPrinterDTOService extends ApiService<KullaniciPrinterDTO>{
    private service = new ApiService("Printer");
    constructor() {
        super("KullaniciPrinterDTO");
    }
    getUserPrinter = (kullaniciId: number) => {
        return this.getOne(kullaniciId);
    };
    UserPrinterInsert = (data: PrinterRequest) => {
        
        return this.service.post<PrinterRequest>("UserPrinterInsert", data);
    };
    UserPrinterUpdate = (data: PrinterRequest) => {
        if (data.kullaniciId > 0) {
            return this.service.post<PrinterRequest>("UserPrinterUpdate", data);
        }
    };
}

export default new KullaniciPrinterDTOService();